import {
  createShippingOption as publicCreateShippingOption,
  getShippingOption as publicGetShippingOption,
  updateShippingOption as publicUpdateShippingOption,
  deleteShippingOption as publicDeleteShippingOption,
  queryShippingOptions as publicQueryShippingOptions,
  typedQueryShippingOptions as publicTypedQueryShippingOptions,
  updateExtendedFields as publicUpdateExtendedFields,
  addDeliveryRegion as publicAddDeliveryRegion,
  removeDeliveryRegion as publicRemoveDeliveryRegion,
} from './ecom-v1-shipping-option-shipping-options.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ShippingOptionQuery,
  ShippingOptionsQueryBuilder,
  typedQueryShippingOptions as universalTypedQueryShippingOptions,
} from './ecom-v1-shipping-option-shipping-options.universal.js';
import { onShippingOptionCreated as publicOnShippingOptionCreated } from './ecom-v1-shipping-option-shipping-options.public.js';
import { onShippingOptionDeleted as publicOnShippingOptionDeleted } from './ecom-v1-shipping-option-shipping-options.public.js';
import { onShippingOptionUpdated as publicOnShippingOptionUpdated } from './ecom-v1-shipping-option-shipping-options.public.js';

function customQueryShippingOptions(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryShippingOptions(httpClient)(),
    typedQueryFunction: (query: ShippingOptionQuery) =>
      publicTypedQueryShippingOptions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ShippingOptionsQueryBuilder;
  function overloadedQuery(
    query: ShippingOptionQuery
  ): ReturnType<typeof universalTypedQueryShippingOptions>;
  function overloadedQuery(query?: ShippingOptionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicCreateShippingOption> &
    typeof publicCreateShippingOption
> = /*#__PURE__*/ createRESTModule(publicCreateShippingOption);
export const getShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicGetShippingOption> &
    typeof publicGetShippingOption
> = /*#__PURE__*/ createRESTModule(publicGetShippingOption);
export const updateShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicUpdateShippingOption> &
    typeof publicUpdateShippingOption
> = /*#__PURE__*/ createRESTModule(publicUpdateShippingOption);
export const deleteShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicDeleteShippingOption> &
    typeof publicDeleteShippingOption
> = /*#__PURE__*/ createRESTModule(publicDeleteShippingOption);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const addDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicAddDeliveryRegion> &
    typeof publicAddDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicAddDeliveryRegion);
export const removeDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDeliveryRegion> &
    typeof publicRemoveDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicRemoveDeliveryRegion);
export const queryShippingOptions: MaybeContext<
  BuildRESTFunction<typeof customQueryShippingOptions> &
    typeof customQueryShippingOptions
> = /*#__PURE__*/ createRESTModule(customQueryShippingOptions);
/**
 * Triggered when a shipping option is created.
 */
export const onShippingOptionCreated: BuildEventDefinition<
  typeof publicOnShippingOptionCreated
> &
  typeof publicOnShippingOptionCreated = /*#__PURE__*/ createEventModule(
  publicOnShippingOptionCreated
);
/**
 * Triggered when a shipping option is deleted.
 */
export const onShippingOptionDeleted: BuildEventDefinition<
  typeof publicOnShippingOptionDeleted
> &
  typeof publicOnShippingOptionDeleted = /*#__PURE__*/ createEventModule(
  publicOnShippingOptionDeleted
);
/**
 * Triggered when a shipping option is updated.
 */
export const onShippingOptionUpdated: BuildEventDefinition<
  typeof publicOnShippingOptionUpdated
> &
  typeof publicOnShippingOptionUpdated = /*#__PURE__*/ createEventModule(
  publicOnShippingOptionUpdated
);

export {
  ConditionType,
  LogicalOperator,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-shipping-option-shipping-options.universal.js';
export {
  ShippingOption,
  ConditionalRates,
  Condition,
  ExtendedFields,
  CreateShippingOptionRequest,
  CreateShippingOptionResponse,
  GetShippingOptionRequest,
  GetShippingOptionResponse,
  UpdateShippingOptionRequest,
  UpdateShippingOptionResponse,
  DeleteShippingOptionRequest,
  DeleteShippingOptionResponse,
  QueryShippingOptionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryShippingOptionsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ShippingOptionCreatedEnvelope,
  ShippingOptionDeletedEnvelope,
  ShippingOptionUpdatedEnvelope,
  UpdateShippingOption,
  ShippingOptionsQueryResult,
  ShippingOptionsQueryBuilder,
  ShippingOptionQuerySpec,
  UpdateExtendedFieldsOptions,
  AddDeliveryRegionOptions,
  RemoveDeliveryRegionOptions,
} from './ecom-v1-shipping-option-shipping-options.universal.js';
export { utils } from './ecom-v1-shipping-option-shipping-options.universal.js';
export {
  ConditionTypeWithLiterals,
  LogicalOperatorWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateShippingOptionApplicationErrors,
  UpdateShippingOptionApplicationErrors,
  CommonQueryWithEntityContext,
  ShippingOptionQuery,
} from './ecom-v1-shipping-option-shipping-options.universal.js';
